import { Component, OnDestroy, OnInit, Self } from '@angular/core';

import { INavbar } from './navbar.types';
import { ActiveTabService } from './active-tab.service';
import { SectionService } from '../../services/section.service';
import { FaqsService } from 'src/app/core/services/faqs-service/faqs.service';
import { NX23NavbarFields } from '../../types/content-types';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'nx-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [SectionService],
})
export class NavbarComponent implements INavbar, OnInit, OnDestroy {
  public data!: NX23NavbarFields;
  private destroyed$ = new Subject<void>();

  constructor(
    @Self() section: SectionService,
    public activeTab: ActiveTabService,
    public faqsService: FaqsService,
  ) {
    section.sectionName = 'header';
  }

  // PROPERTIES
  isMenuOpen!: boolean;

  // METHODS
  menuToggle(isOpen: boolean): void {
    this.isMenuOpen = isOpen;
    if (isOpen) {
      document.body.classList.add('stop-scroll');
    } else {
      document.body.classList.remove('stop-scroll');
    }
  }

  // HOOKS
  ngOnInit(): void {
    this.faqsService
      .getNavbar()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data: any) => {
        this.data = data.fields;
        this.activeTab.updateActiveTab(this.data.tabs);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }
}
